module.exports = __webpack_public_path__ + "img/competencies_swiper_12.43f0d0b6.jpg";